import React, { MouseEventHandler, ReactNode } from 'react'
import { Box, Typography } from '@mui/material'

import WidgetButton, {
  WidgetButtonProps,
  WidgetButtonType,
} from './WidgetButton'
import ActionBar from './ActionBar'

interface BodyHeaderProps {
  title: string
  subtitle?: string
  isHeaderCentered?: boolean
}

const BodyHeader = (props: BodyHeaderProps) => {
  return (
    <Box sx={{ marginBottom: '2rem' }}>
      <Typography
        sx={{
          textAlign: props.isHeaderCentered ? 'center' : 'left',
        }}
        variant={'h1'}
      >
        {props.title}
      </Typography>
      {props.subtitle && (
        <Typography
          sx={{
            textAlign: props.isHeaderCentered ? 'center' : 'left',
          }}
        >
          {props.subtitle}
        </Typography>
      )}
    </Box>
  )
}

interface WidgetBodyProps {
  sx?: object
  children: ReactNode
  title: string
  subtitle?: string
  isHeaderCentered?: boolean
  onBack?: MouseEventHandler<HTMLButtonElement>
  onContinue?: MouseEventHandler<HTMLButtonElement>
  otherActions?: Array<WidgetButtonProps>
  isSubmitting?: boolean
  ctaIcon?: ReactNode
  ctaLabel?: string
  pageKey?: string
}

const WidgetBody = (props: WidgetBodyProps) => {
  return (
    <>
      <ActionBar backAction={props.onBack} otherActions={props.otherActions} />
      <BodyHeader
        isHeaderCentered={props.isHeaderCentered}
        title={props.title}
        subtitle={props.subtitle}
      />
      <Box sx={theme => ({ marginBottom: theme.spacing(4) })}>
        {props.children}
      </Box>
      {props.ctaLabel && (
        <WidgetButton
          action={props.onContinue}
          type={WidgetButtonType.Cta}
          label={props.ctaLabel}
          icon={props.ctaIcon}
          isSubmitting={props.isSubmitting}
          isLoading={props.isSubmitting}
        />
      )}
    </>
  )
}

export default WidgetBody

WidgetBody.defaultProps = {
  ctaLabel: 'Continue',
}
